import React from 'react';
import { useFilingContext } from '@/finsight/application/Filings/FilingsContext';
import SectorCell from '@/finsight/ui/components/filings/filingsCells/SectorCell';
import LoanLevelNameCell from '@/finsight/ui/components/filings/filingsCells/LoanLevelNameCell';
import StratsLinkCell from '@/finsight/ui/components/filings/filingsCells/StratsLinkCell';
import DateCell from '@/finsight/ui/components/filings/filingsCells/DateCell';
import DownloadLinksCell from '@/finsight/ui/components/filings/filingsCells/DownloadLinksCell';

import tableRowStyles from './tableRow.scss';

interface IProps {
  filingIndex: number,
}

const TableRow = ({ filingIndex }: IProps) => {
  const { collection: filings, xml2csvUrlTpl } = useFilingContext();
  const filing = filings[filingIndex];

  return (
    <tr className={ tableRowStyles.row }>
      <SectorCell
        rowIndex={ filingIndex }
        // @ts-ignore
        filing={ filing }
      />
      <LoanLevelNameCell
        rowIndex={ filingIndex }
        // @ts-ignore
        filing={ filing }
      />
      <StratsLinkCell
        rowIndex={ filingIndex }
        // @ts-ignore
        filing={ filing }
      />
      <DateCell
        customClassName={ tableRowStyles.dateCell }
        rowIndex={ filingIndex }
        // @ts-ignore
        filing={ filing }
      />
      <DownloadLinksCell
        customClassName={ tableRowStyles.downloadLinksCell }
        rowIndex={ filingIndex }
        filing={
          {
            // @ts-ignore
            ...filing,
            xml2csvUrlTpl,
          }
        }
      />
    </tr>
  );
};

export default TableRow;
